import { UIEditorBlockWidth } from '../WidthSelectControl';
import { DefaultProps, DictionaryType } from './types';

export const InputDefaultProps: DefaultProps = {
  isEditable: false,
  size: UIEditorBlockWidth.Quarter,
  isLabel: false,
  label: '',
  isMultiline: false,
  format: '',
  isMandatory: false,
  isShared: false,
  dictionaryType: DictionaryType.DropDown,
  isOptionAllowed: true,
  isSingleValue: false,
  expression: '',
  visibleOptionsNumber: 10,
  isHiddenWhenEmpty: undefined,
};
